import { render, staticRenderFns } from "./ArticleBlock.vue?vue&type=template&id=3a2cfa55&"
import script from "./ArticleBlock.vue?vue&type=script&lang=ts&"
export * from "./ArticleBlock.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports